import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeLabel: {
		id: 'project-create-importer-upload-flow.common.missing-fields-modal.close-label',
		defaultMessage: 'Close modal',
		description: 'Label for cross button in the modal',
	},
});
